// Documentos que lee "Rellenar con IA" sobre TanStack Query. A diferencia del
// resto del mantenedor, guardar NO invalida la lista: el servidor responde la
// pestaña ya resuelta y se escribe en la caché, que evita un viaje por guardado.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  fetchRellenoDocumentos,
  guardarRellenoDocumentosRequest,
  type EntradaDeLaLista,
  type RellenoDocumentos,
} from "@/lib/rellenoDocumentos";

export const RELLENO_DOCUMENTOS_KEY = ["ia", "relleno-documentos"] as const;

export function useRellenoDocumentos() {
  return useQuery({
    queryKey: RELLENO_DOCUMENTOS_KEY,
    queryFn: fetchRellenoDocumentos,
  });
}

export function useGuardarRellenoDocumentos() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ pestana, lista }: { pestana: string; lista: EntradaDeLaLista[] }) =>
      guardarRellenoDocumentosRequest(pestana, lista),
    onSuccess: (pestanaGuardada) => {
      queryClient.setQueryData<RellenoDocumentos>(RELLENO_DOCUMENTOS_KEY, (actual) =>
        actual
          ? {
              ...actual,
              pestanas: actual.pestanas.map((p) => (p.id === pestanaGuardada.id ? pestanaGuardada : p)),
            }
          : actual,
      );
    },
  });
}
